import React, { useState, useEffect } from "react";
import Navbar from "../Components/Navbar";
import { Axios } from "../config";
import "../Style/LandingPage.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

function HomePage() {
  const [events, setEvents] = useState([]);
  const [Runs, setRuns] = useState([]);
  const [Fours, setFours] = useState([]);
  const [Sixes, setSixes] = useState([]);
  const [Averages, setAverages] = useState([]);
  const [Wickets, setWickets] = useState([]);
  const [Economy, setEconomy] = useState([]);
  const [Catches, setCatches] = useState([]);
  const [RunOuts, setRunOuts] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [games, setGames] = useState([]);
  const [selectedFormat, setSelectedFormat] = useState("All");
  const [selectedTeam, setSelectedTeam] = useState("All");
  const [showPastGames, setShowPastGames] = useState(false);

  useEffect(() => {
    fetchData();
    fetchGames();
  }, []);

  const fetchGames = () => {
    Axios.post("/GetSeasonGamesData") // use POST to match the existing endpoint, drop /api/
      .then((response) => {
        console.log("Games fetched:", response.data); // verify data is coming through
        const sorted = response.data.slice().sort(
          (a, b) => toLocalDate(a.DateAndTime) - toLocalDate(b.DateAndTime)
        );
        setGames(sorted);
      })
      .catch((error) => {
        console.error("Error fetching games:", error);
      });
  };

  const fetchData = () => {
    Axios.get("/upcomingEvents")
      .then((response) => {
        setEvents(response.data);
      })
      .catch((error) => {
        console.error("Error fetching events:", error);
      });

    Axios.post("/GetOverAllPlayersData")
      .then((response) => {
        const sortedPlayersRuns = response.data.sort(
          (a, b) => b.RunsScored - a.RunsScored,
        );
        setRuns(sortedPlayersRuns.slice(0, 3));

        const sortedPlayersFours = [...response.data].sort(
          (a, b) => b.Fours - a.Fours,
        );
        setFours(sortedPlayersFours.slice(0, 3));

        const sortedPlayersSixes = [...response.data].sort(
          (a, b) => b.Sixes - a.Sixes,
        );
        setSixes(sortedPlayersSixes.slice(0, 3));

        const sortedPlayersAverage = response.data
          .filter((player) => player.BattingAverage !== null)
          .sort((a, b) => b.BattingAverage - a.BattingAverage);
        setAverages(sortedPlayersAverage.slice(0, 3));

        const sortedPlayersWickets = [...response.data].sort(
          (a, b) => b.WicketsTaken - a.WicketsTaken,
        );
        setWickets(sortedPlayersWickets.slice(0, 3));

        const sortedPlayersEconomy = response.data
          .filter(
            (player) =>
              player.BowlingEconomy !== null && player.OversBowled > 10,
          )
          .sort((a, b) => a.BowlingEconomy - b.BowlingEconomy);
        setEconomy(sortedPlayersEconomy.slice(0, 3));

        const sortedPlayersCatches = [...response.data].sort(
          (a, b) => b.CatchesTaken - a.CatchesTaken,
        );
        setCatches(sortedPlayersCatches.slice(0, 3));

        const sortedPlayersRunOuts = [...response.data].sort(
          (a, b) => b.RunOuts - a.RunOuts,
        );
        setRunOuts(sortedPlayersRunOuts.slice(0, 3));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev > 0 ? prev - 1 : events.length - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev + 1) % events.length);
  };

  // Derive unique formats and teams from the games data for filter dropdowns
  const formats = [
    "All",
    ...new Set(games.map((g) => g.Format).filter(Boolean)),
  ];
  const teams = [
    "All",
    "Shaheen Mavericks",
    "Shaheen Gladiators",
    "Shaheen Warriors",
    "Shaheen Knights",
    "Shaheen Titans",
  ];

  const [visibleCount, setVisibleCount] = useState(10);

  // DB times are stored in America/Edmonton (Mountain) time without timezone suffix.
  // dateStrings:true on the pool ensures DATETIME arrives as "YYYY-MM-DD HH:MM:SS".
  // Appending the offset explicitly prevents UTC misinterpretation on non-Mountain hosts.
  const toLocalDate = (dateString) => {
    const normalized = String(dateString).replace("T", " ").replace("Z", "").split(".")[0];
    const [datePart, timePart] = normalized.split(" ");
    const month = parseInt(datePart.split("-")[1], 10);
    const offset = month >= 4 && month <= 10 ? "-06:00" : "-07:00";
    return new Date(`${datePart}T${timePart}${offset}`);
  };

  const getTodayMDT = () => {
    const now = new Date();
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Edmonton",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(now);
    const year = parts.find((p) => p.type === "year").value;
    const month = parts.find((p) => p.type === "month").value;
    const day = parts.find((p) => p.type === "day").value;
    const monthNum = parseInt(month, 10);
    const offset = monthNum >= 4 && monthNum <= 10 ? "-06:00" : "-07:00";
    return new Date(`${year}-${month}-${day}T00:00:00${offset}`);
  };

  const filteredGames = games.filter((game) => {
    const matchesFormat =
      selectedFormat === "All" || game.Format === selectedFormat;
    const matchesTeam =
      selectedTeam === "All" || game.GameDetails.includes(selectedTeam);
    if (!matchesFormat || !matchesTeam) return false;
    if (!showPastGames) {
      return toLocalDate(game.DateAndTime) >= getTodayMDT();
    }
    return true;
  });

  const visibleGames = filteredGames.slice(0, visibleCount);
  const loadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  // Group games by date for a cleaner display
  const groupedGames = visibleGames.reduce((groups, game) => {
    const dateObj = toLocalDate(game.DateAndTime);

    const date = dateObj.toLocaleDateString("en-CA", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      timeZone: "America/Edmonton",
    });

    if (!groups[date]) groups[date] = [];
    groups[date].push(game);
    return groups;
  }, {});

  const formatTime = (dateString) => {
    const date = toLocalDate(dateString);

    return date.toLocaleTimeString("en-CA", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "America/Edmonton",
    });
  };

  return (
    <>
      <Navbar />

      <div className="LandingPage1">
        <div>
          <span className="Name">Shaheen Cricket Club</span>
          <br />
          <span className="address">Calgary, Alberta</span>
        </div>
      </div>

      <div className="LandingPage2">
        <div>
          <span className="AboutSectionHeader">About Section</span>
          <br />
          <span className="AboutSectionContent">
            <a className="no-decoration" href="/AdminLogin">
              Shaheen Cricket Club
            </a>{" "}
            was founded in 2022 with a clear vision: to promote fair play,
            mutual respect, and a deep love for the game of cricket. In just a
            few short years, Shaheen has grown rapidly, earning recognition not
            only across Calgary but beyond its borders as well.
          </span>
          <br />
          <span className="AboutSectionContent">
            Today, Shaheen stands proudly as one of the largest and most
            successful cricket clubs in Calgary. With a passionate community,
            competitive spirit, and a commitment to excellence, we continue to
            thrive-consistently competing at the highest level and bringing home
            trophies along the way.
          </span>
          <br />
          <div className="social-links" style={{ marginTop: "50px" }}>
            <a
              href="https://www.facebook.com/ShaheenCC.YYC"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              style={{ marginLeft: "10px" }}
            >
              <i className="fab fa-facebook-f"></i>
            </a>
            <a
              href="https://www.instagram.com/shaheenccyyc/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="LandingPage3">
        <h1>Upcoming Events</h1>
        <div className="carousel-container">
          {events.length > 0 ? (
            <>
              <div
                className="carousel-track"
                style={{
                  transform: `translateX(-${currentSlide * 100}%)`,
                  transition: "transform 0.5s ease-in-out",
                }}
              >
                {events.map((event) => (
                  <div className="carousel-slide" key={event.EventID}>
                    <div className="carousel-slide-content">
                      <h3>{event.EventName}</h3>
                      <p>{new Date(event.Date).toLocaleString()}</p>
                      <p>{event.Description}</p>
                      <p>{event.Location}</p>
                      <div className="top-30">
                        {event.TicketsLink && (
                          <a
                            href={event.TicketsLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="carousel-button"
                          >
                            Buy Tickets
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              {events.length > 1 && (
                <div className="carousel-buttons">
                  <button className="carousel-button" onClick={handlePrev}>
                    Previous
                  </button>
                  <button className="carousel-button" onClick={handleNext}>
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="no-events-message">
              <p>No upcoming events scheduled. Check back later!</p>
            </div>
          )}
        </div>
      </div>

      {/* ── GAMES SCHEDULE SECTION ── */}
      <div className="games-section" id="schedule">
        <h1>2026 Season Schedule</h1>

        {/* Filters */}
        <div className="games-filters">
          <div className="filter-group">
            <label>Format</label>
            <div className="filter-buttons">
              {formats.map((fmt) => (
                <button
                  key={fmt}
                  className={`filter-btn ${selectedFormat === fmt ? "active" : ""}`}
                  onClick={() => setSelectedFormat(fmt)}
                >
                  {fmt}
                </button>
              ))}
            </div>
          </div>
          <div className="filter-group">
            <label>Team</label>
            <div className="filter-buttons">
              {teams.map((team) => (
                <button
                  key={team}
                  className={`filter-btn ${selectedTeam === team ? "active" : ""}`}
                  onClick={() => setSelectedTeam(team)}
                >
                  {team === "All" ? "All Teams" : team.replace("Shaheen ", "")}
                </button>
              ))}
            </div>
          </div>
          <div className="filter-group">
            <label className="toggle-label">
              <span>Show past games</span>
              <button
                className={`toggle-switch ${showPastGames ? "on" : ""}`}
                onClick={() => {
                  setShowPastGames((prev) => !prev);
                  setVisibleCount(10);
                }}
                aria-pressed={showPastGames}
              >
                <span className="toggle-thumb" />
              </button>
            </label>
          </div>
        </div>

        {/* Games List grouped by date */}
        {Object.keys(groupedGames).length > 0 ? (
          <div className="games-list">
            {Object.entries(groupedGames).map(([date, dayGames]) => (
              <div key={date} className="games-day-group">
                <div className="games-day-header">{date}</div>
                {dayGames.map((game) => (
                  <div
                    key={game.GameID}
                    className={`game-card ${game.IsUmpiring ? "umpiring" : "playing"}`}
                  >
                    <div className="game-card-left">
                      <span
                        className={`game-format-badge format-${game.Format?.replace(/\s+/g, "-").toLowerCase()}`}
                      >
                        {game.Format}
                      </span>
                      {game.IsUmpiring ? (
                        <span className="umpiring-badge">
                          <i className="fas fa-whistle"></i> Umpiring
                        </span>
                      ) : null}
                    </div>
                    <div className="game-card-middle">
                      <p className="game-details">{game.GameDetails}</p>
                      <p className="game-venue">
                        <i className="fas fa-map-marker-alt"></i> {game.Venue}
                      </p>
                    </div>
                    <div className="game-card-right">
                      <span className="game-time">
                        <i className="fas fa-clock"></i>{" "}
                        {formatTime(game.DateAndTime)}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        ) : (
          <div className="no-events-message">
            <p>No games found for the selected filters.</p>
          </div>
        )}
        {visibleCount < filteredGames.length && (
          <div style={{ textAlign: "center", marginTop: "20px" }}>
            <button className="filter-btn active" onClick={loadMore}>
              Load More
            </button>
          </div>
        )}
      </div>

      <div className="stats-section">
        <h1>Player Statistics (2025)</h1>

        <div className="stats-container">
          <div className="stat-card">
            <h3>Top Run Scorers</h3>
            {Runs.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.RunsScored}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Most Fours</h3>
            {Fours.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.Fours}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Most Sixes</h3>
            {Sixes.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.Sixes}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Highest Average</h3>
            {Averages.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.BattingAverage}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Most Wickets</h3>
            {Wickets.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.WicketsTaken}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Best Economy</h3>
            {Economy.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.BowlingEconomy}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Most Catches</h3>
            {Catches.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.CatchesTaken}</span>
              </div>
            ))}
          </div>

          <div className="stat-card">
            <h3>Most Run Outs</h3>
            {RunOuts.map((player, index) => (
              <div key={player.PlayerID} className="player-stat">
                <span className="rank">{index + 1}.</span>
                <span className="player-name">{player.PlayerName}</span>
                <span className="stat-value">{player.RunOuts}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="executive-section">
        <h1>Executive Committee</h1>

        <div className="committee-container">
          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>President</h3>
            <p>Zain Arshad</p>
          </div>

          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>Vice President</h3>
            <p>Ammar Maqsud</p>
          </div>

          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>Secretary</h3>
            <p>Annas Imtiaz</p>
          </div>

          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>Treasurer</h3>
            <p>Tauha Pasha</p>
          </div>

          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>Director of Operations</h3>
            <p>Talha Paracha</p>
          </div>

          <div className="committee-card">
            <div className="member-photo">
              <div className="photo-placeholder"></div>
            </div>
            <h3>Director of Communications</h3>
            <p>Mir Soban Ahmed</p>
          </div>
        </div>
      </div>

      <footer className="site-footer">
        <div className="footer-content">
          <div className="footer-info">
            <p>&copy; 2025 Shaheen Cricket Club. All rights reserved.</p>
            <p>Calgary, Alberta</p>
          </div>
          <div className="footer-contact">
            <p>
              Email:{" "}
              <a href="mailto:shaheenccyyc@gmail.com">shaheenccyyc@gmail.com</a>
            </p>
          </div>
          <div className="footer-credits">
            <p>
              Made and maintained by <strong>scratchZero</strong> 2025
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default HomePage;
